// Core-js polyfills for missing modules

// Array polyfills
if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement, fromIndex) {
    return this.indexOf(searchElement, fromIndex) !== -1;
  };
}

if (!Array.from) {
  Array.from = function (arrayLike, mapFn, thisArg) {
    "use strict";
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    var C = this;
    var items = Object(arrayLike);

    if (arrayLike == null) {
      throw new TypeError("Array.from requires an array-like object - not null or undefined");
    }

    // If mapFn is undefined, then it will not be invoked.
    if (mapFn !== undefined && !isCallable(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }

    // 7. If mapfn is undefined, let mapping be false.
    var mapMapping = mapFn !== undefined;
    var T;
    if (mapMapping) {
      T = thisArg;
    }

    // Check for iterable
    var getIterator = function (obj) {
      var iteratorSymbol = (typeof Symbol !== "undefined" && Symbol.iterator) || "@@iterator";
      if (obj != null && typeof obj[iteratorSymbol] === "function") {
        return obj[iteratorSymbol]();
      }
      return null;
    };

    var iterator = getIterator(items);
    var A, k, kValue, mappedValue;

    if (iterator) {
      // Handle iterables (like Map, Set, etc.)
      A = isCallable(C) ? Object(new C()) : [];
      k = 0;
      var step;
      while (!(step = iterator.next()).done) {
        kValue = step.value;
        if (mapMapping) {
          mappedValue = mapFn.call(T, kValue, k);
        } else {
          mappedValue = kValue;
        }
        A[k] = mappedValue;
        k += 1;
      }
      A.length = k;
      return A;
    } else {
      // Handle array-like objects
      var len = toLength(items.length);
      A = isCallable(C) ? Object(new C(len)) : new Array(len);
      k = 0;
      while (k < len) {
        kValue = items[k];
        if (mapMapping) {
          mappedValue = mapFn.call(T, kValue, k);
        } else {
          mappedValue = kValue;
        }
        A[k] = mappedValue;
        k += 1;
      }
      A.length = len;
      return A;
    }
  };
}

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate, thisArg) {
    for (let i = 0; i < this.length; i++) {
      if (predicate.call(thisArg, this[i], i, this)) {
        return this[i];
      }
    }
    return undefined;
  };
}

// Math polyfills
if (!Math.log2) {
  Math.log2 = function (x) {
    return Math.log(x) / Math.LN2;
  };
}

// Number polyfills
if (!Number.isNaN) {
  Number.isNaN = function (value) {
    return typeof value === "number" && isNaN(value);
  };
}

if (!Number.isInteger) {
  Number.isInteger = function (value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };
}

// Object polyfills
if (!Object.values) {
  Object.values = function (obj) {
    return Object.keys(obj).map((key) => obj[key]);
  };
}

// Promise polyfill (basic)
if (typeof Promise === "undefined") {
  window.Promise = class Promise {
    constructor(executor) {
      this.state = "pending";
      this.value = undefined;
      this.handlers = [];

      const resolve = (value) => {
        if (this.state === "pending") {
          this.state = "fulfilled";
          this.value = value;
          this.handlers.forEach((handler) => handler.onFulfilled(value));
        }
      };

      const reject = (reason) => {
        if (this.state === "pending") {
          this.state = "rejected";
          this.value = reason;
          this.handlers.forEach((handler) => handler.onRejected(reason));
        }
      };

      try {
        executor(resolve, reject);
      } catch (error) {
        reject(error);
      }
    }

    then(onFulfilled, onRejected) {
      return new Promise((resolve, reject) => {
        const handle = () => {
          if (this.state === "fulfilled") {
            if (typeof onFulfilled === "function") {
              try {
                resolve(onFulfilled(this.value));
              } catch (error) {
                reject(error);
              }
            } else {
              resolve(this.value);
            }
          } else if (this.state === "rejected") {
            if (typeof onRejected === "function") {
              try {
                resolve(onRejected(this.value));
              } catch (error) {
                reject(error);
              }
            } else {
              reject(this.value);
            }
          }
        };

        if (this.state === "pending") {
          this.handlers.push({ onFulfilled, onRejected: handle });
        } else {
          setTimeout(handle, 0);
        }
      });
    }

    catch(onRejected) {
      return this.then(null, onRejected);
    }
  };
}

// WeakMap polyfill (basic)
if (typeof WeakMap === "undefined") {
  window.WeakMap = class WeakMap {
    constructor() {
      this._keys = [];
      this._values = [];
    }

    set(key, value) {
      const index = this._keys.indexOf(key);
      if (index === -1) {
        this._keys.push(key);
        this._values.push(value);
      } else {
        this._values[index] = value;
      }
      return this;
    }

    get(key) {
      const index = this._keys.indexOf(key);
      return index === -1 ? undefined : this._values[index];
    }

    has(key) {
      return this._keys.indexOf(key) !== -1;
    }

    delete(key) {
      const index = this._keys.indexOf(key);
      if (index !== -1) {
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
        return true;
      }
      return false;
    }
  };
}

// Symbol polyfill (basic)
if (typeof Symbol === "undefined") {
  window.Symbol = function Symbol(description) {
    const symbol = Object.create(null);
    symbol.toString = () => `Symbol(${description || ""})`;
    symbol.valueOf = () => symbol;
    return symbol;
  };

  Symbol.asyncIterator = Symbol("Symbol.asyncIterator");
  Symbol.iterator = Symbol("Symbol.iterator");
}

// Array iterator polyfill (es6.array.iterator)
if (Array.prototype && !Array.prototype[Symbol.iterator]) {
  Array.prototype[Symbol.iterator] = function () {
    let index = 0;
    const array = this;
    return {
      next: function () {
        if (index < array.length) {
          return { value: array[index++], done: false };
        } else {
          return { done: true };
        }
      },
    };
  };
}

// NodeList forEach polyfill (web.dom-collections.for-each)
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// HTMLCollection forEach polyfill
if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
  HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

// atob/btoa polyfills (web.atob)
if (typeof window !== "undefined") {
  if (!window.atob) {
    window.atob = function (str) {
      return Buffer.from(str, "base64").toString("binary");
    };
  }

  if (!window.btoa) {
    window.btoa = function (str) {
      return Buffer.from(str, "binary").toString("base64");
    };
  }
}

export {};
